/**
 * Labstep
 */

import { SLASH_TRIGGER } from 'labstep-web/constants/prosemirror';
import { submitElement } from 'labstep-web/prosemirror/extensions/slash/commands/actions';
import commandsPlugin from 'labstep-web/prosemirror/extensions/slash/plugin';
import type { IStateDispatchProps } from 'labstep-web/prosemirror/marks/types';
import { replaceWithNode } from 'labstep-web/prosemirror/nodes/commands';
import { NodeConditions } from 'labstep-web/prosemirror/nodes/conditions';
import { getToken } from 'labstep-web/prosemirror/utils/selection';

/**
 * Replace token with conditions node
 * @param state State
 * @param dispatch Dispatch
 */
export const createConditionsNode = (
  state: IStateDispatchProps['state'],
  dispatch: IStateDispatchProps['dispatch'],
): void => {
  const token = getToken(state, SLASH_TRIGGER);
  if (!token) {
    return;
  }
  const { from, to } = token;
  replaceWithNode(state, dispatch, from, to, NodeConditions.key);
};

/**
 * Submit conditions element so we can open modal from within Modal/Add
 * @param state State
 * @param dispatch Dispatch
 */
export const createConditionsNodeAndSubmitElement = (
  state: IStateDispatchProps['state'],
  dispatch: IStateDispatchProps['dispatch'],
): void => {
  const dispatchWithSubmitElement: IStateDispatchProps['dispatch'] = (
    tr,
  ) => {
    tr.setMeta(commandsPlugin, submitElement('conditions'));
    dispatch?.(tr);
  };
  createConditionsNode(state, dispatchWithSubmitElement);
};
